import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-warn',
  templateUrl: './warn.component.html',
  styleUrls: ['./warn.component.scss']
})
export class WarnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
